/**
 * Assignment Periods API Client (Epic 3 — Toewijzing met tijdspercentages en
 * tijdvakken, Story 3.2)
 *
 * `lib/<resource>Api.ts`-conventie (ARCHITECTURE-SPINE.md, Consistency
 * Conventions), zelfde structuur als `coreTasksApi.ts`.
 */

import { apiRequest } from './api';
import type { AssignmentPeriodDTO, PeriodInput } from '@functieloonhuis/shared';

interface DataResponse<T> {
  data: T;
}

export const assignmentPeriodsApi = {
  /** Alle tijdvakken van een medewerker (open + gesloten), nieuwste eerst. */
  list: async (employeeId: number): Promise<AssignmentPeriodDTO[]> => {
    const res = await apiRequest<DataResponse<AssignmentPeriodDTO[]>>(`/employees/${employeeId}/task-periods`);
    return res.data;
  },

  /** Opent een nieuw tijdvak (pakketwissel) — sluit automatisch het lopende open tijdvak. */
  open: async (employeeId: number, input: PeriodInput): Promise<AssignmentPeriodDTO> => {
    const res = await apiRequest<DataResponse<AssignmentPeriodDTO>>(`/employees/${employeeId}/task-periods`, {
      method: 'POST',
      body: JSON.stringify(input),
    });
    return res.data;
  },

  /** Wijzigt een bestaand (open, niet-bevroren) tijdvak. */
  update: async (employeeId: number, periodId: number, input: PeriodInput): Promise<AssignmentPeriodDTO> => {
    const res = await apiRequest<DataResponse<AssignmentPeriodDTO>>(
      `/employees/${employeeId}/task-periods/${periodId}`,
      { method: 'PUT', body: JSON.stringify(input) }
    );
    return res.data;
  },
};
